<template>
  <div>
    <b-tabs>
      <b-tab
        :title="`${this.$t('menu.settings.alertsNewsletters.titleGeneral')}`"
        active
      >
        <general-bulletin />
      </b-tab>
      <b-tab
        :title="`${this.$t('menu.settings.alertsNewsletters.titleBranch')}`"
      >
        <branch-bulletin />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import GeneralBulletin from '@/components/organisms/settings/bulletins/general-bulletin';
import BranchBulletin from '@/components/organisms/settings/bulletins/branch-bulletin';

export default {
  components: { GeneralBulletin, BranchBulletin },
  data: () => ({
    userAuth: null,
  }),

  computed: {},

  methods: {},

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.input-area {
  display: flex;
  flex-direction: row;
}

.chip {
  padding: 3px 15px;
  font-size: 16px;
  border-radius: 20px;
  float: left;
  margin: 2px;
  background-color: $gray;
  border: 1px solid $white;
  color: $white;
  display: flex;
  align-items: center;
}

.closebtn {
  padding-left: 10px;
  color: $white;
  font-weight: bold;
  float: right;
  font-size: 15px;
  opacity: 0.6;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/bulletins/index.vue